import React, { FC, ReactNode } from 'react';
import BiDialog from 'view/shared/components/dialogs/bi-dialog/bi-dialog';

interface Props {
	pdfUrl: string;
	title: string;
	visible: boolean;
	onHide: () => void;
	dismissable?: boolean;
	actionButton?: ReactNode;
}

export const PdfViewerDialog: FC<Props> = React.memo(
	({ pdfUrl, title, visible, onHide, dismissable = true, actionButton }) => {
		if (!visible) {
			return null;
		}

		return (
			<BiDialog modal={true} showHeader={false} dismissableMask={dismissable} onHide={onHide} visible={true}>
				<div className="flex-space-between-row">
					<div className="text-wrapper">
						<h2 className="text-bold title">{title}</h2>
					</div>
				</div>
				<object data={pdfUrl} type="application/pdf" width="1000" height="700">
					<p>
						Unable to display PDF file. <a href={pdfUrl}>Download</a> instead.
					</p>
				</object>
				{actionButton && <div className="flex-end-row margin-top-10px">{actionButton}</div>}
			</BiDialog>
		);
	}
);
